module.exports = __webpack_public_path__ + "img/principal.e4219b33.jpg";